module.exports = __webpack_public_path__ + "img/store-mssql.6d953e30.svg";